module.exports = __webpack_public_path__ + "img/9788957981917.b213db67.jpg";